import { Component, Input} from '@angular/core';

@Component({
    selector: 'lib-full-name',
    templateUrl: './full-name.component.html',
    styleUrls: ['./full-name.component.css'],
    standalone: false
})
export class FullNameComponent {
  @Input() row:any;
}
